import request from "./../utils/request";

export async function getRawMaterialCategoryList(payload) {
  return request.get("RawMaterialCategory/List", {
    params: {
      rawMaterialCategoryId: payload.rawMaterialCategory != null ? payload.rawMaterialCategory.id : null,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
    }
  });
}

export async function deleteRawMaterialCategory(id){
  return request.delete("RawMaterialCategory/Delete?id=" + id);
}

export async function createRawMaterialCategory(payload){
  return request.post("RawMaterialCategory/Create",payload);
}

export async function updateRawMaterialCategory(payload){
  return request.post("RawMaterialCategory/Update",payload)
}

export async function getRawMaterialCategoryNameList() {
  return request.get("RawMaterialCategory/NameList");
}
